import { connect } from 'react-redux'
import { actions } from 'src/features/mobileMenu/MobileMenuSlice'
import { actions as searchActions } from 'src/features/river/RiverSlice'
import MobileMenu from 'src/features/mobileMenu/components/MobileMenu'

const mapDispatchToProps = dispatch => ({
  doSearchCall: query => dispatch(searchActions.redirectSearch(query)),
  handleSlideMenu: () => dispatch(actions.toggleLeftMenu())
})

const mapStateToProps = state => ({
  open: state.mobileMenuReducer.leftMenuOpen,
  position: 'left'
})

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenu)
